"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _revalidate = require("revalidate");

var _emailValidator = require("email-validator");

var checkLengthLessThan = function checkLengthLessThan(count) {
  return (0, _revalidate.createValidator)(function (message) {
    return function (value) {
      if (value.length < count) {
        return "The message is too short. Please enter a brief description of your request.";
      }

      return null;
    };
  }, function (field) {
    return "The message can not be blank. Please enter a brief description of your request.";
  });
};

var isValidEmail = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (!(0, _emailValidator.validate)(value)) {
      return message;
    }
  };
}, function (field) {
  return field + " doesn't seem to be valid";
});

var validate = (0, _revalidate.combineValidators)({
  name: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(2))("Name"),

  email: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidEmail)("Email"),

  subject: (0, _revalidate.composeValidators)(_revalidate.isRequired)("Subject"),

  comments: (0, _revalidate.composeValidators)((0, _revalidate.isRequired)({
    message: "The message can not be blank. Please enter a brief description of your request."
  }), checkLengthLessThan(50))("Comments")
});

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/contactUsFormValidation.js
// module id = 2788
// module chunks = 0